import React from "react";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "./DashboardCard";

function CustomersDashboard() {
  const { data } = UseGetDashBoardData(`/dashboard/customerStats`);
  const percentage = parseFloat(data?.new_customers_count) || 0;
  const isNegative = percentage < 0;

  const CustomerIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Total Customers"
      value={data?.total_customers_count || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={CustomerIcon}
      bgColor="bg-[#048178]/10"
      iconColor="text-[#048178]"
      badgeLabel="new this month"
    />
  );
}

export default CustomersDashboard;
